module.exports = __webpack_public_path__ + "img/pass2024.95f2205b.png";